/**
 * Input rules for the login and forgot-password forms (security audit:
 * Improper Input Validation).
 *
 * The server is the control: kvs_vsk_backend src/shared/validation/authInput.ts
 * refuses anything outside these shapes whatever the browser does. These
 * copies only stop malformed input from being sent, and tell the user why in
 * plain words. Keep the patterns identical to the server's.
 */

/** Letters, digits, dot, underscore, hyphen; starts with a letter or digit; 3-50 characters (shape KV.1101). */
export const LOGIN_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._-]{2,49}$/;
export const LOGIN_ID_MAX_LENGTH = 50;

/** Six letters or digits, the length of every CAPTCHA the server issues. */
export const CAPTCHA_VALUE_PATTERN = /^[A-Za-z0-9]{6}$/;
export const CAPTCHA_LENGTH = 6;

export const LOGIN_ID_MESSAGE =
  'Enter a valid Login ID. It can contain letters, digits, dots, hyphens and underscores only.';
export const CAPTCHA_MESSAGE = 'Enter the 6 characters shown in the captcha.';

/** The first problem with a Login ID + CAPTCHA pair, or null when both are acceptable. */
export function loginFormError(loginId: string, captcha: string): string | null {
  if (!LOGIN_ID_PATTERN.test(loginId.trim())) return LOGIN_ID_MESSAGE;
  if (!CAPTCHA_VALUE_PATTERN.test(captcha.trim())) return CAPTCHA_MESSAGE;
  return null;
}
